import React, {Component} from "react";
import {connect} from "react-redux";
import CarouselItem from "../../../../blocks/CarouselItem";
import MiniLegend from "../../../../items/MiniLegend";
import Source from "../../../../items/Source";

import {BarChart} from "d3plus-react";

import {removeDecimalsIfNotNeeded, cloneAndRenameObj, calculateDomain} from "../../../../../helpers/formatters";


class CurrentSectorMix extends Component {

  render() {
    const {clustersData, selectedRegion, nuts3Data} = this.props;

    const selectedRegionID = selectedRegion.id;
    const nuts3Datum = nuts3Data.find(n3 => n3.id === selectedRegionID);

    if (!nuts3Datum) {
      return '';
    }
    const avgData = clustersData.find(cd => cd.cluster_id === nuts3Datum.cluster_id);

    if (!avgData) {
      return '';
    }
    avgData.color = "#cccccc";
    avgData.name = `${avgData.cluster_name} Cluster average`;

    const renameFields = {
      'nuts_3_region_employment_share_in_knowledge_intensive_services_2018_in_share': 'employment_share_in_knowledge_intensive_services_2018_in_share',
      'nuts_3_region_employment_share_in_non_techincal_services_2018_in_share': 'employment_share_in_non_techincal_services_2018_in_share',
      'nuts_3_region_employment_share_in_public_sector_and_healthcare_2018_in_share': 'employment_share_in_public_sector_and_healthcare_2018_in_share',
      'nuts_3_region_employment_share_in_construction_2018_in_share': 'employment_share_in_construction_2018_in_share',
      'nuts_3_region_employment_share_in_industry_2018_in_share': 'employment_share_in_industry_2018_in_share',
      'nuts_3_region_employment_share_in_agriculture_2018_in_share': 'employment_share_in_agriculture_2018_in_share',
      'name': 'name'
    };

    const smallNuts3Data = cloneAndRenameObj(nuts3Datum, renameFields);
    smallNuts3Data.color = "#38bdf3";

    const filteredData = [
      avgData,
      smallNuts3Data
    ];

    const colors = filteredData.map(d => ({color: d.color, label: d.name}));

    // share of EU startups?? no data..
    // share of EU high tech?? no data..
    const fields = {
      'employment_share_in_knowledge_intensive_services_2018_in_share': '<b>Knowledge intensive services</b>',
      'employment_share_in_non_techincal_services_2018_in_share': '<b>Non-technical services</b>',
      'employment_share_in_public_sector_and_healthcare_2018_in_share': '<b>Public sector & healthcare</b>',
      'employment_share_in_construction_2018_in_share': '<b>Construction</b>',
      'employment_share_in_industry_2018_in_share': '<b>Manufacturing</b>',
      'employment_share_in_agriculture_2018_in_share': '<b>Agriculture</b>'
    };

    const finalData = [];
    let xMax = 0;
    let xMin = 0;
    let value;
    Object.keys(fields).forEach(f => {
      filteredData.forEach(fd => {
        value = fd[f];
        finalData.push({name: fd.name, property: fields[f], value: value, color: fd.color});
        xMax = xMax < value ? value : xMax;
        xMin = xMin > value ? value:xMin;
      });
    });

    const chartConfig = {
      data: finalData,
      detectVisible: true,
      groupBy: "name",
      height: 450,
      legend:false,
      discrete: "y",
      y: "property",
      x: "value",
      tooltipConfig: {
        body: d => `<div>${d.property} employment share: ${removeDecimalsIfNotNeeded(d.value * 100)}%</div>`
      },
      yConfig: {
        title: false,
        minSize: 150
      },
      xConfig: {
        // labels: [0, Math.floor(xMax)],
        title: false,
        tickFormat: x => `${Math.round(x*100)}%`,
        domain: calculateDomain(xMin, xMax)
      },
      shapeConfig: {
        fill: d => d.color,
        label: d => false,
        duration: 0,
        Bar: {
          label: (d) => (`${removeDecimalsIfNotNeeded(d.value * 100)}%`)
        }
      },
      groupPadding: 25,
      barPadding: 2,
      legendTooltip: {
        body: "",
        footer: "",
      },
      on: {"click.legend": () => {}}
    };
    return (
      <CarouselItem title="Current sector mix" subtitle={<><b>Prevailing sector mix,</b> 2018, %</>}>
        <div className="fow-col fow-col-1">
          <MiniLegend colors={colors} />
          <BarChart config={chartConfig} />
          <Source text="Source: Eurostat, Oxford Economics; McKinsey Global Institute analysis" />
        </div>
      </CarouselItem>
    );
  }
}

const mapStateToProps = state => {
  return {
    nuts3Data: state.db.data.facts.nuts3 ? state.db.data.facts.nuts3 : [],
    clustersData: state.db.data.facts.clusters_avg ? state.db.data.facts.clusters_avg : [],
    selectedRegion: state.settings.map["Regions"]
  };
};
const mapDispatchToProps = dispatch => ({});

export default connect(mapStateToProps, mapDispatchToProps)(CurrentSectorMix);
